module.exports = __webpack_public_path__ + "img/security-200.a6029e56.gif";